import { SEARCH_PARAMETERS_SCHEMA } from './schema';
import { SearchParameters } from './searchParameters';
import { SearchParameterDeserializer, type SearchQuery } from './serialization';

/**
 * Builds a search from a url query.
 *
 * Only this direction needs a factory: a query is raw text that has to be
 * read against the schema before it is a search. Changing a search needs no
 * factory — `SearchParameters#with` is the one way to do it, and every caller
 * that wants to already holds the search.
 */
export class SearchParametersFactory {
  readonly #deserializer: SearchParameterDeserializer;

  constructor(
    deserializer = new SearchParameterDeserializer(SEARCH_PARAMETERS_SCHEMA)
  ) {
    this.#deserializer = deserializer;
  }

  fromQuery = (query: SearchQuery): SearchParameters =>
    new SearchParameters(this.#deserializer.deserialize(query));
}
